import { useBreakpointValue } from '@gemini/core';
export const useBreakpoint = () => {
    const device = useBreakpointValue({
        base: 'mobile',
        sm: 'tablet',
        md: 'tablet',
        lg: 'desktop',
    });
    return {
        isDesktop: device === 'desktop',
        isMobile: device === 'mobile',
        isTablet: device === 'tablet',
    };
};
